import { axiosInstance } from "./";

const ADMIN_COMPANY_ROLES_PATH = "/company_roles";

/** GET /api/admin_portal/v2/company_roles — list/search company roles. */
const getAdminCompanyRoles = (params = {}, config = {}) =>
  axiosInstance.get(ADMIN_COMPANY_ROLES_PATH, { ...config, params });

/** GET /api/admin_portal/v2/company_roles/:id — show one role + permissions. */
const getAdminCompanyRole = (id) =>
  axiosInstance.get(`${ADMIN_COMPANY_ROLES_PATH}/${id}`);

/** POST /api/admin_portal/v2/company_roles — create a role. */
const createAdminCompanyRole = (data) =>
  axiosInstance.post(ADMIN_COMPANY_ROLES_PATH, data);

/** PATCH /api/admin_portal/v2/company_roles/:id — update role. */
const updateAdminCompanyRole = ({ id, data }) =>
  axiosInstance.patch(`${ADMIN_COMPANY_ROLES_PATH}/${id}`, data);

/** DELETE /api/admin_portal/v2/company_roles/:id — delete a role. */
const deleteAdminCompanyRole = (id) =>
  axiosInstance.delete(`${ADMIN_COMPANY_ROLES_PATH}/${id}`);

export {
  getAdminCompanyRoles,
  getAdminCompanyRole,
  createAdminCompanyRole,
  updateAdminCompanyRole,
  deleteAdminCompanyRole,
};
